import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ReplaySubject, Subject, catchError, throwError, takeUntil } from 'rxjs';
import { Group } from 'src/app/models/group';
import { SampleGroupModel } from 'src/app/models/sample-group-model';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';
import { AddNewGroupComponent } from '../add-new-group/add-new-group.component';

@Component({
    selector: 'app-move-sample',
    templateUrl: './move-sample.component.html',
    styleUrls: ['./move-sample.component.css'],
    standalone: false
})
export class MoveSampleComponent {

  newGroupForm: FormGroup;

  userId:number = 0;
  tenantId:number = 0;

  public groupFilterCtrl: FormControl<string> = new FormControl<string>('');
  public filteredSampleGroups: ReplaySubject<SampleGroupModel[]> = new ReplaySubject<SampleGroupModel[]>(1);
  protected _onGroupDestroy = new Subject<void>();
  groups = [];
  group: Group;
  selectedGroups: number[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public editAddGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private newGroupFb: FormBuilder,
      public addGroupDialog: MatDialog,
      private groupService: GroupService,
      public nav: NavBarComponent,
  ) {
    this.newGroupForm = this.newGroupFb.group({
      sampleGroup: new FormControl(null)
    });
  }
  ngOnInit(): void {
    if(this.data){
      this.userId = this.data.userId;
      this.tenantId = this.data.tenantId;
      this.selectedGroups = this.data.selectedGroups;
    }
    this.populateGroupDropdown();
  }

  populateGroupDropdown(groupId?: number){
    this.groupService.getGroups(this.tenantId).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((result) =>{
      for(let group of result) {
        if(!this.selectedGroups?.includes(group?.id)) {
          this.groups.push(group);
        }
      }

      if(groupId) {
        let group = this.groups.find(g => g.id === groupId);
        this.newGroupForm.controls.sampleGroup.setValue(group);
      }
      this.setInitialGroupList();
      this.nav.toggleLoading(false);
    })
  }

  setInitialGroupList() {
    // Load the initial group list
    this.filteredSampleGroups.next(this.groups.slice());
    // Listen for search field value changes
    this.groupFilterCtrl.valueChanges
      .pipe(takeUntil(this._onGroupDestroy))
      .subscribe(() => {
        this.filterGroups();
      });
  }


  protected filterGroups() {
    if (!this.groups) {
      return;
    }
    // Get the search keyword
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredSampleGroups.next(this.groups.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter the group based on the search keyword
    this.filteredSampleGroups.next(
      this.groups.filter(group => group.name.toLowerCase().indexOf(search) > -1)
    );
  }


  addNewGroup(){
    const dialogRef = this.addGroupDialog.open(AddNewGroupComponent, {
      data: {
        userId: this.userId,
        tenantId: this.tenantId,
      },
      width: '420px'
    });

    dialogRef.afterClosed().subscribe(groupId => {
      if(groupId) {
        this.populateGroupDropdown(groupId);
      }
    });
  }


  close(){
    this.editAddGroupDialog.close({"option": "cancel"});
  }

  setSelectedGroup(group){
      this.group = group;
      this.newGroupForm.controls.sampleGroup.setValue(this.group);

  }

  move(){
       let  groupObj = {
          option: 'move',
          groupId: this.group.id
        }
        this.editAddGroupDialog.close({groupObj});
       
  }

  ngOnDestroy() {
    this._onGroupDestroy.next();
    this._onGroupDestroy.complete();
  }
}
